export interface ReplyItem {
  author: string;
  authorTag: string;
  time: string;
  content: string;
  likes: number;
  isMine?: boolean;
}

export default function ReplyList({ replies }: { replies: ReplyItem[] }) {
  return (
    <div className="divide-y divide-background-200">
      {replies.map((reply, index) => (
        <article key={`${reply.author}-${index}`} className="flex gap-4 py-5">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-sm font-medium text-secondary-800">
            {reply.author.slice(0, 1)}
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
              <span className="text-sm font-medium text-foreground-950">{reply.author}</span>
              <span className="rounded bg-primary-50 px-1.5 py-0.5 text-primary-700">
                {reply.authorTag}
              </span>
              <span>{reply.time}</span>
              <span className="ml-auto rounded bg-background-100 px-2 py-0.5">
                {index + 2} 楼
              </span>
            </div>
            <p className="mt-2.5 text-sm leading-relaxed text-foreground-700">{reply.content}</p>
            <div className="mt-3 flex items-center gap-4 text-xs text-foreground-400">
              <button
                type="button"
                className="flex items-center gap-1 transition-colors hover:text-accent-600"
              >
                <i className="ri-thumb-up-line" />
                {reply.likes}
              </button>
              <button
                type="button"
                className="flex items-center gap-1 transition-colors hover:text-primary-700"
              >
                <i className="ri-reply-line" />
                回复
              </button>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}